import {useContext} from "react";

import Card from "../ui/Card";
import classes from './ArticleItem.module.scss';
import FavouritesContext from "../../store/favourites-context";
import {Link} from "react-router-dom";
import UserContext from "../../store/userContext";
import ArticleService from "../../services/ArticleService";
import FavouriteButton from "../ui/functional/FavouriteButton";
import CategoryInImage from "../frontpage/CategoryInImage";
import SiteContext from "../../store/siteContext";
import SiteService from "../../services/SiteService";

function ArticleItem({article, articleClickAction}){
	const categories = useContext(SiteContext).categories;

	if (!article.category) {
		if (article.categories && article.categories.length > 0) {
			try {
				// find the category for the part's first category
				article.category = categories.find((cat) => {
					return cat._id === article.categories[0];
				}).name;
			} catch (e) {
				console.error('Could not find category for part', article.title||article._id);
			}
		}
	}


	return(
		<li className={classes.item}>
			<FavouriteButton articleId={article._id} addText={false} stroke={'white'}></FavouriteButton>
			<Card>
				<Link className={classes.cardLink} to={'/artikkel/' + article.urlString} onClick={(ev)=>{
					if (articleClickAction) {
						ev.preventDefault();
						articleClickAction(article);
					}
				}}>
					<div style={{position:'relative'}}>
						<CategoryInImage part={article}/>
						<div className={classes.imageOverlay}></div>
						<img className={classes.image} alt={article.image.alt} src={`${SiteService.apiPath}/image/articles/${article._id}/header-medium.webp`}></img>
					</div>
					<div className={classes.content}>
						<h3>{article.name}</h3>
						<div>
							<time dateTime={article.date.substring(0,10)}>{article.date.substring(0,10).split('-').reverse().join('-')}</time>
							<u>{articleClickAction?'Velg':''}</u>
						</div>
					</div>
				</Link>
			</Card>
		</li>
	)
}

export default ArticleItem;